module.exports = __webpack_public_path__ + "img/company36.7d8fd8ba.png";